export default __webpack_public_path__ + "static/media/Icon_Camera_Blue.00fe40d0.png";